<template>
  <base-dialog @cancel="close">
    <div slot="header">{{$t('common.text00089')}}</div>
    <div class="error-body" slot="body">
      <div v-if="!ticketAvailable">
        <a-alert :message="ticketTips"  type="warning"  />
        <!--        // 如果工单不能正常提交则显示 技术支持电话 / 提交Issue / 微信群 二维码-->
        <tech-support />
        <a-divider>{{ $t('scope.text_433') }}</a-divider>
      </div>
      <slot />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="submitTicket" icon="tool" :loading="loading" v-if="ticketAvailable">{{ $t('scope.error.help') }}</a-button>
      <a-button @click="close">{{ $t('scope.text_457') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import TechSupport from '@scope/sections/TechSupport'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TicketSubmitDialog',
  components: { TechSupport },
  mixins: [DialogMixin, WindowsMixin],
  props: {
    // 只有在嵌套dialog时才需要此方法
    closeDialog: {
      type: Function,
      required: false,
    },
    ticketAvailable: {
      type: Boolean,
      default: true,
    },
    getTicketCreateData: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      ticketMan: new this.$Manager('process-instances', 'v1'),
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    ticketTips () {
      const login = this.$store.state.auth.canRenderDefaultLayout
      if (!login) return this.$t('scope.error.contacts.tips.login')
      return this.$t('scope.error.contacts.tips')
    },
  },
  methods: {
    close () {
      this.cancelDialog()
      if (typeof this.closeDialog === 'function') {
        this.closeDialog()
      }
    },
    ticketSubmitting () {
      this.loading = true
      this.$message.info(this.$t('scope.error.ticket_submitting'))
    },
    ticketSubmitted () {
      this.loading = false
      this.$message.success(this.$t('scope.error.ticket_submitted'))
      this.close()
    },
    async submitTicket () {
      if (!this.ticketAvailable) return
      const ticketData = this.getTicketCreateData()
      if (ticketData.variables && ticketData.variables.comment && ticketData.variables.comment.length > 3900) {
        ticketData.variables.comment = ticketData.variables.comment.substr(0, 3900) + '...'
      }
      try {
        this.ticketSubmitting()
        await this.ticketMan.create({ data: ticketData })
        this.ticketSubmitted()
      } catch (e) {
        this.ticketSubmitted()
        throw e
      }
    },
  },
}
</script>

<style lang="less" scoped>
.error-body {
  .label {
    width: 80px;
  }
}
</style>
